import React from "react";
import Draggable from "react-draggable";
import { Popover, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { editorCursor } from "../utils/editorCursor";

const DraggableTunnelLink = ({
  symbol,
  position,
  bounds,
  onDragStop,
  onDelete,
  upperLaneY,
  lowerLaneY,
  isActive,
}) => {
  const lineHeight = lowerLaneY - upperLaneY;
  const lineWidth = 4;

  const popoverContent = (
    <div style={{ minWidth: 150 }}>
      <div style={{ marginBottom: 8 }}>
        <strong>聯絡道</strong>
      </div>
      <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>
        <div>類型: 建築結構</div>
        <div>位置: {symbol.position_meters?.x?.toFixed(2)}m</div>
      </div>
      {onDelete && (
        <Button
          size="small"
          danger
          block
          icon={<DeleteOutlined />}
          onClick={() => onDelete(symbol.id)}
        >
          移除物件
        </Button>
      )}
    </div>
  );

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        pointerEvents: "none",
      }}
    >
      <Draggable
        axis="x"
        position={position || { x: 50, y: upperLaneY }}
        onStop={(e, data) => onDragStop(symbol.id, data)}
        bounds={bounds}
        disabled={!isActive}
      >
        <div
          style={{
            cursor: editorCursor("edit", "lane", { locked: !isActive }),
            userSelect: "none",
            pointerEvents: "auto",
            display: "block",
            width: lineWidth,
            height: lineHeight,
            padding: 0,
            margin: 0,
            boxSizing: "border-box",
          }}
        >
          <Popover content={popoverContent} trigger="hover" placement="top">
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "#8c8c8c",
                borderRadius: 1,
                transition: "opacity 0.2s ease",
                position: "relative",
                opacity: 0.7,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "0.7";
              }}
            />
          </Popover>
        </div>
      </Draggable>
    </div>
  );
};

export default DraggableTunnelLink;

